export default "__VITE_ASSET__DGM7vZW0__"